import "../plugins/element.js";
import { MessageBox, TimeSelect, Message } from "element-ui";
import axios from "axios";
import { test_url } from "../api/index";
import { getRsaKey } from "../api/common";
import { timeFun,GetDateTime } from "./public.js";

// import Rsa from './Rsa.js';
export default {
  install(Vue) {
    // 把confirm挂载到vue的原型对象上
    Vue.prototype.$confirm = MessageBox.confirm;
    Vue.filter("yuan", function(value) {
      return value / 1000;
    });
    Vue.filter("dateFormat", function(value) {
      return timeFun("cnshort",value);
    });
    // 获取年月日yy-mm-dd hh:ff:ss
    Vue.prototype.testR = function(res) {
      if (res == undefined || !res) {
        Message.error("错误的返回值！");
        return false;
      }
      if (res.data.return_code == "FAIL" || res.data.return_msg) {
        Message.error(res.data.return_msg);
        return false;
      } else if (res.data.result_code == "FAIL" || res.data.result_msg) {
        Message.error(res.data.result_msg);
        return false;
      } else if (res.data.error_code == "FAIL" || res.data.error_msg) {
        Message.error(res.data.error_msg);
        return false;
      } else if (
        res.data.return_code == "SUCCESS" &&
        res.data.result_code == "SUCCESS" &&
        res.data.resp_data &&
        res.data.resp_data.isSuccess == false
      ) {
        Message.error(res.data.resp_data.msg);
        return false;
      } else if (
        res.data.return_code == "SUCCESS" &&
        res.data.result_code == "SUCCESS" &&
        res.data.resp_data
      ) {
        return true;
      }
    };
    Vue.prototype.formatDate = function(date = new Date()) {
      let time_str = "";
      let yy = new Date(date).getFullYear();
      // let mm = (new Date().getMonth() + 1) < 10 ? '0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1);
      var month = new Date().getMonth() + 1;
      let mm = (month < 10 ? "0" : "") + month;
      let dd =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate();
      let hh =
        new Date().getHours() < 10
          ? "0" + new Date().getHours()
          : new Date().getHours();
      let mf =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      time_str = yy + "-" + mm + "-" + dd + " " + hh + ":" + mf + ":" + ss;
      return time_str;
    };
    //yymmdd
    Vue.prototype.getDateStr = function() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      month = (month < 10 ? "0" : "") + month;
      // 获取当前是几号
      var day = date.getDate();
      day = (day < 10 ? "0" : "") + day;
      return String(year) + month + day;
    };
    // 最后拼接字符串，得到一个格式为(yyyy-MM-dd)的日期
    Vue.prototype.requestDate = function(date = new Date()) {
      // 获取当前月份
      var nowMonth = date.getMonth() + 1;
      // 获取当前是几号
      var strDate = date.getDate();
      // 添加分隔符“-”
      var seperator = "-";
      // 对月份进行处理，1-9月在前面添加一个“0”
      if (nowMonth >= 1 && nowMonth <= 9) {
        nowMonth = "0" + nowMonth;
      }
      // 对月份进行处理，1-9号在前面添加一个“0”
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      // 最后拼接字符串，得到一个格式为(yyyy-MM-dd)的日期
      var nowDate =
        date.getFullYear() + seperator + nowMonth + seperator + strDate;
      return nowDate;
    };
    Vue.prototype.myFixed = function(num, digit) {
      if (Object.is(parseFloat(num), NaN)) {
        return console.log(`传入的值：${num}不是一个数字`);
      }
      num = parseFloat(num);
      return (
        Math.round((num + Number.EPSILON) * Math.pow(10, digit)) /
        Math.pow(10, digit)
      ).toFixed(digit);
    };
    // 获取年月日时分秒 yymmddhhffss
    Vue.prototype.DateNow = function() {
      //获取当前时间并打印
      var _this = this;
      let yy = new Date().getFullYear();
      // let mm = (new Date().getMonth() + 1) < 10 ? '0' + (new Date().getMonth() + 1) : (new Date().getMonth() + 1);
      var month = new Date().getMonth() + 1;
      let mm = (month < 10 ? "0" : "") + month;
      let dd =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate();
      let hh =
        new Date().getHours() < 10
          ? "0" + new Date().getHours()
          : new Date().getHours();
      let mf =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let ss =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      _this.gettime = yy + mm + dd + hh + mf + ss;
      return _this.gettime;
    };
    //获取随机字符串传入len
    Vue.prototype.RandomStr = function(len) {
      var code;
      code = "";
      //设置随机字符
      var random = new Array(
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "g",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z"
      );

      //循环codeLength 我设置的4就是循环4次

      for (let i = 0; i < len; i++) {
        //设置随机数范围,这设置为0 ~ 62
        var index = Math.floor(Math.random() * 36);
        //字符串拼接 将每次随机的字符 进行拼接
        code += random[index];
      }
      return code;
    };
    /**
     * 获取16位的字符串
     * @param {Number} len 返回字符长度
     * @param {10|36|62} count 随机字符包含哪些值 10(0-9) 36(0-9 a-z) 62(0-9 a-z A-Z)
     * @returns string len长度的随机字符串
     */
    Vue.prototype.getKey = function(len = 32, count = 62) {
      var code;
      //首先默认code为空字符串
      code = "";
      //设置长度，这里看需求，这里设置了32
      var codeLength = len;
      //设置随机字符
      var random = new Array(
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "g",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
      );

      //循环codeLength 我设置的4就是循环4次

      for (var i = 0; i < codeLength; i++) {
        //设置随机数范围,这设置为0 ~ 62
        var index = Math.floor(Math.random() * count);
        //字符串拼接 将每次随机的字符 进行拼接
        code += random[index];
      }
      return code;
    };

    Vue.prototype.$account = {};
    // 封装警告消息
    Vue.prototype.warnMessage = function(message) {
      this.$message({
        message: message,
        type: "warning"
      });
    };
    Vue.prototype.successMessage = function(message) {
      this.$message({
        message: message,
        type: "success"
      });
    };
    // 获取二维码图片url
    Vue.prototype.getUrl = function(token) {
      return axios.get(this.$url + "account/register?code=" + token + "");
    };
    // 获取微信openid
    Vue.prototype.getOpenId = function(token) {
      return axios.get(this.$url + "account/registerStatus?code=" + token);
    };
    // 获取状态
    /*         Vue.prototype.getRegisterStatus = function(){
                        return axios.get(this.$url+"account/registerStatus")
                    } */
    // 计算签名
    Vue.prototype.getSign = function(obj) {
      var sign = "";
      var sortObj = Object.keys(obj).sort();
      for (var i = 0; i < sortObj.length; i++) {
        sign += sortObj[i] + "=" + obj[sortObj[i]] + "&";
      }
      sign = sign.substring(0, sign.length - 1);
      sign = this.$md5(sign).toLowerCase();
      return sign;
    };
    // Rsa加密

    Vue.prototype.encrypt = async function(str) {
      var { data: res } = await this.$Rsa.getKey(
        this.$url + "common/GetSysKey"
      );
      return this.$Rsa.encrypt(str, res.public_key);
    };
    Vue.prototype.$encrypt = async function(str) {
      return await this.$Rsa.encrypt(
        JSON.stringify({
          time_stamp: this.formatDate(),
          plaintext: str
        }),
        await getRsaKey()
      );
    };
    Vue.prototype.rFileSize = function(size) {
      return size / 1024 / 1024;
    };
    Vue.prototype.$post = function(url, obj) {
      return axios.post(url, obj, {
        headers: {
          "content-type": "application/json"
        }
      });
    };
    Vue.prototype.getToken = async function() {
      var obj = {
        account_id: JSON.parse(window.sessionStorage.getItem("account"))
          .account_id,
        pass_word: window.sessionStorage.getItem("pass_word"),
        mch_no: window.sessionStorage.getItem("current_merchant_id"),
        nonce_str: this.getKey(16, 62)
      };
      obj.sign = this.getSign(obj);
      obj.pass_word = await this.encrypt(obj.pass_word);
      const data = await this.$http.post(
        this.$url + "/common/GenerateAccessToken",
        JSON.stringify(obj),
        {
          headers: {
            "content-type": "application/json"
          }
        }
      );
      return data;
    };
    Vue.prototype.unique = function(arr) {
      return Array.from(new Set(arr));
    };
    /* Vue.prototype.formatDate = function(date, tRFC = false) {
      var datearr = date.toString().split(" ");
      var rdate = "";
      switch (datearr[1]) {
        case "Jan":
          rdate = datearr[3] + "-01-" + datearr[2];
          break;
        case "Feb":
          rdate = datearr[3] + "-02-" + datearr[2];
          break;
        case "Mar":
          rdate = datearr[3] + "-03-" + datearr[2];
          break;
        case "Apr":
          rdate = datearr[3] + "-04-" + datearr[2];
          break;
        case "May":
          rdate = datearr[3] + "-05-" + datearr[2];
          break;
        case "Jun":
          rdate = datearr[3] + "-06-" + datearr[2];
          break;
        case "Jul":
          rdate = datearr[3] + "-07-" + datearr[2];
          break;
        case "Aug":
          rdate = datearr[3] + "-08-" + datearr[2];
          break;
        case "Sep":
          rdate = datearr[3] + "-09-" + datearr[2];
          break;
        case "Oct":
          rdate = datearr[3] + "-10-" + datearr[2];
          break;
        case "Nov":
          rdate = datearr[3] + "-11-" + datearr[2];
          break;
        case "Dec":
          rdate = datearr[3] + "-12-" + datearr[2];
          break;
      }
      if (tRFC == true) {
        return rdate + "T" + datearr[4] + "+08:00";
      } else {
        return rdate;
      }
    }; */
    /* Vue.prototype.strUtf8 = function(str) {
                var encoder = new TextEncoder('utf8');
                return encoder.encode(str);
            } */
  }
};
